import React from "react"

import { arrayOf, shape, string } from "prop-types"

function DetailRows({ rows }) {
  return (
    <div className="model-details-card__rows">
      {rows.map(({ label, value }) => (
        <div className="model-details-card__row" key={label}>
          <p className="model-details-card__label cgt-overline-sm">{label}</p>
          <p className="model-details-card__value cgt-caption-semibold">{value}</p>
        </div>
      ))}
    </div>
  )
}

DetailRows.propTypes = {
  rows: arrayOf(shape({ label: string.isRequired, value: string.isRequired })).isRequired,
}

export default DetailRows
